// The maps' switch, for a map that says the company's maps are off (QA-756): "Turn on in Settings" goes
// to its Setup page, opened on its row. Shared by an address's map (AddressOnMap) and the day's map
// (DayMapOrGoogle).
import { RULE_SECTIONS } from '../settings/settings-model.ts';
import { findSetting } from '../settings/rule-data.ts';

const MAPS_SETTING = 'maps.google';
/** The maps' switch: its Setup page, opened on its row. */
export const MAPS_TURN_ON = {
  href: `#/settings/${RULE_SECTIONS.find((s) => s.rules.some((r) => r.key === MAPS_SETTING))!.page}`,
  onOpen: () => findSetting(MAPS_SETTING),
};
